import type { PreloadedQuery } from 'react-relay';
import { createAri } from '@atlassian/jira-platform-ari/src/index.tsx';
import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { QueryParams } from '@atlassian/jira-vulnerability-url-parameter-utils/src/common/types.tsx';
// eslint-disable-next-line jira/import-whitelist
import { getGqlFiltersFromQueryParams } from '@atlassian/jira-vulnerability-url-parameter-utils/src/controllers/get-gql-filters-from-query-params/index.tsx';
import type {
	RouterDataContext,
	ResourceStoreContext,
	RouterContext,
	RouteResource,
} from '@atlassian/react-resource-router';
import MAIN_SECURITY_PAGE_QUERY, {
	type mainSecurityInJiraQuery,
} from '@atlassian/jira-software-security-page/src/ui/__generated__/mainSecurityInJiraQuery.graphql';
import { RESOURCE_TYPE_SECURITY } from '../constants.tsx';

const getNumberOfVulnerabilitiesToFetch = (): number => 40;

const getNumberOfSecurityContainersToFetch = (): number => 100;

let filters: ReturnType<typeof getGqlFiltersFromQueryParams> | undefined;
export const securityPageResource: RouteResource<
	PreloadedQuery<mainSecurityInJiraQuery, Record<string, unknown>>
> = createRelayResource<mainSecurityInJiraQuery>({
	type: RESOURCE_TYPE_SECURITY,
	getQuery(
		{ match: { params }, query, route: { name } }: RouterDataContext | RouterContext,
		{ tenantContext: { cloudId, activationId } }: ResourceStoreContext,
	) {
		const isSecRoute = name === 'software-security' || name === 'software-security-classic';
		// Set filters on initial call only and not on every query param change
		if (!filters && isSecRoute) {
			const connectionAri = createAri({
				resourceOwner: 'jira',
				resourceType: 'security-container',
				cloudId,
				activationId,
				resourceId: '',
			});
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			filters = getGqlFiltersFromQueryParams(query as QueryParams, connectionAri);
		}
		// Reset filters when navigating away from the security page
		if (!isSecRoute) {
			filters = undefined;
		}
		return {
			parameters: MAIN_SECURITY_PAGE_QUERY,
			options: {
				fetchPolicy: 'store-and-network',
			},
			variables: {
				cloudAri: createAri({
					resourceOwner: 'jira',
					resourceType: 'site',
					resourceId: cloudId,
				}),
				cloudId,
				projectKey: params.projectKey ?? '',
				numberOfVulnsToFetch: getNumberOfVulnerabilitiesToFetch(),
				getContainers: false,
				numberOfContainersToFetch: getNumberOfSecurityContainersToFetch(),
				filter: filters,
				isVulnsListFixEnabled: fg('jira-security-vulns-list-fix-enabled'),
			},
		};
	},
});
